import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

// This component is used to protect routes that require authentication
export default function ProtectedRoute({ children }) {
  const { currentUser, authEnabled } = useAuth();
  const location = useLocation();

  // If Firebase auth is not properly configured, allow access to the protected route
  // This prevents the app from breaking when Firebase credentials are missing/invalid
  if (!authEnabled) {
    console.warn(
      'Firebase Auth is not properly configured. Protected routes are temporarily accessible without authentication.'
    );
    return children;
  }

  // If user is not authenticated, redirect to login
  // Pass the current location to the login page so we can redirect back after login
  if (!currentUser) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // If user is authenticated, render the protected route
  return children;
}
